import _regeneratorRuntime from "/Users/mohammedshalabi/Projects/hakawati/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createForOfIteratorHelper from "/Users/mohammedshalabi/Projects/hakawati/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/Users/mohammedshalabi/Projects/hakawati/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/mohammedshalabi/Projects/hakawati/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/mohammedshalabi/Projects/hakawati/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/mohammedshalabi/Projects/hakawati/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/mohammedshalabi/Projects/hakawati/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { ExternalInteractorBase } from "../../../Core/Utils/ExternalInteractorBase";
import { isInArray } from "../../../Utils/Utils";
export var Connector = /*#__PURE__*/function (_ExternalInteractorBa) {
  _inherits(Connector, _ExternalInteractorBa);

  var _super = _createSuper(Connector);

  function Connector(container) {
    _classCallCheck(this, Connector);

    return _super.call(this, container);
  }

  _createClass(Connector, [{
    key: "isEnabled",
    value: function isEnabled() {
      var container = this.container,
          mouse = container.interactivity.mouse,
          events = container.actualOptions.interactivity.events;

      if (!(events.onHover.enable && mouse.position)) {
        return false;
      }

      return isInArray("connect", events.onHover.mode);
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function () {
      var _interact = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var container, options, mousePos, distance, query, i, _iterator, _step, p1, pos1, _iterator2, _step2, p2, pos2, distMax, xDiff, yDiff;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                container = this.container, options = container.actualOptions;

                if (!(options.interactivity.events.onHover.enable && container.interactivity.status === "mousemove")) {
                  _context.next = 9;
                  break;
                }

                mousePos = container.interactivity.mouse.position;

                if (mousePos) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                distance = Math.abs(container.retina.connectModeRadius), query = container.particles.quadTree.queryCircle(mousePos, distance);
                i = 0;
                _iterator = _createForOfIteratorHelper(query);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    p1 = _step.value;
                    pos1 = p1.getPosition();
                    _iterator2 = _createForOfIteratorHelper(query.slice(i + 1));

                    try {
                      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                        p2 = _step2.value;
                        pos2 = p2.getPosition(), distMax = Math.abs(container.retina.connectModeDistance), xDiff = Math.abs(pos1.x - pos2.x), yDiff = Math.abs(pos1.y - pos2.y);

                        if (xDiff < distMax && yDiff < distMax) {
                          container.canvas.drawConnectLine(p1, p2);
                        }
                      }
                    } catch (err) {
                      _iterator2.e(err);
                    } finally {
                      _iterator2.f();
                    }

                    ++i;
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function interact() {
        return _interact.apply(this, arguments);
      }

      return interact;
    }()
  }]);

  return Connector;
}(ExternalInteractorBase);